/**
 * MaddymoneyCharts.
 * @returns {any}
 */
export default function MaddymoneyCharts() {
  return {
    type: 'french-tech',
    period: 'monthly',
    data: [],
    chart: null,
    loading: false,
    index: 0,
    async updateChartData() {
      this.loading = true;
      const urlPrefix =
        document.documentElement.lang !== 'en-UK' || location.hostname.endsWith('.ddev.site')
          ? ''
          : '/uk';
      const response = await fetch(
        `${urlPrefix}/wp-json/maddyness/graphics?type=${this.type}&period=${this.period}`,
      );
      const data = await response.json();
      this.data = data;
      this.redraw();
    },
    mounted() {
      this.resizeSelect();
      this.updateChartData();
    },
    handlePeriodChange() {
      setTimeout(() => {
        this.data = [];
        this.updateChartData();
      }, 0);
      this.resizeSelect();
    },
    resizeSelect() {
      if (!this.$refs.period) {
        return;
      }
      const selectedOption = this.$refs.period.querySelector('option:checked');
      const text = selectedOption ? selectedOption.textContent : '';

      const testSpan = document.createElement('span');
      testSpan.innerHTML = text;
      testSpan.style.visibility = 'hidden';

      this.$refs.period.parentNode.append(testSpan);
      const width = testSpan.offsetWidth + 20;
      testSpan.remove();

      this.$refs.period.style.width = `${width}px`;
    },
    async redraw() {
      const { init } = await import('echarts');
      const data = this.data[this.index];
      const xAxisData = data.map((row) => row.label);
      const amountData = data.map((row) => row.amount);
      const operationsData = data.map((row) => row.operations_count);

      const barChart = init(this.$refs['bar-chart']);
      barChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        legend: {
          data: ['Fonds levées', 'Opérations'],
          bottom: 'left',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            dataView: { show: false, readOnly: false },
            magicType: { show: false, type: ['line', 'bar'] },
            restore: { show: false },
            saveAsImage: { show: false },
          },
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisPointer: {
            type: 'shadow',
          },
        },
        yAxis: [
          {
            type: 'value',
            name: 'Fonds levées',
            axisLabel: {
              formatter(value) {
                return `${value / 1000000} M€`;
              },
            },
          },
          {
            type: 'value',
            name: 'Opérations',
            axisLabel: {
              formatter: '{value}',
            },
          },
        ],
        series: [
          {
            name: 'Fonds levées',
            type: 'bar',
            tooltip: {
              valueFormatter(value) {
                const formattedValue = value / 1000000;
                return `${Number.parseFloat(formattedValue).toFixed(1)} M€`;
              },
            },
            color: ['#3e68ff'],
            data: amountData,
          },
          {
            name: 'Opérations',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter(value) {
                return `${value}`;
              },
            },
            color: ['#FFB2FC'],
            data: operationsData,
            smooth: true,
          },
        ],
      });

      barChart.on('finished', () => {
        this.loading = false;
      });
    },
    handlePrev() {
      if (this.index >= 1) {
        this.index -= 1;
        this.redraw();
      }
    },
    handleNext() {
      this.index += 1;
      this.redraw();
    },
  };
}
